import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/FieldFlags'


// create the fragment store

export class FieldFlagsStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "FieldFlagsStore",
			variables: true,
			
		})
	}
}
